// extracted by mini-css-extract-plugin
export default {"wrapper":"Account_wrapper__HmrVX","title":"Account_title__Pja6o"};